import { createAction, props } from "@ngrx/store";
import { sessionAuthData } from "../../interfaces/states-data";

export const __updateSessionAuth = createAction(
    '[Session Auth] Update',
    props<sessionAuthData>(),
)

export const __clearSessionAuth = createAction(
    '[Session Auth] Clear'
)